export default function createEventManager() {
  const listeners = {};

  return {
    on(eventName, callback) {
      if (!listeners[eventName]) {
        listeners[eventName] = [];
      }
      listeners[eventName].push(callback);
    },
    off(eventName, callback) {
      if (!listeners[eventName]) return;
      const index = listeners[eventName].indexOf(callback);
      if (index !== -1) {
        listeners[eventName].splice(index, 1);
      }
    },
    emit(eventName, data) {
      if (!listeners[eventName]) return;
      listeners[eventName].forEach(callback => callback(data));
    },
  };
}
